import { IVacanciesFilter } from 'src/pages/vacancies/vacancies.interfaces';

const filterData = (value: any[] = []) =>
  Object.entries(value).flatMap(([key, value]) => (value ? [key] : []));

const getInitialCheckList = (items: string[] = []) =>
  items.reduce((init: { [key: string]: boolean }, curr: string) => ({ ...init, [curr]: true }), {});

export const getInitialFilterData = (filter: IVacanciesFilter) => ({
  companiesIds: getInitialCheckList(filter.companiesIds),
  statuses: getInitialCheckList(filter.statuses),
});

export const getFilteredData = (values: IVacanciesFilter) => ({
  companiesIds: filterData(values.companiesIds),
  statuses: filterData(values.statuses),
});
